/**
 * Created by work on 17/6/15.
 */
export const REFRESH_PATCH_ITEMDATA = 'REFRESH_PATCH_ITEMDATA';

export const refreshPatchItemData = (patchItemData) => ({
  type: REFRESH_PATCH_ITEMDATA,
  patchItemData
});


// WEBPACK FOOTER //
// ./src/actions/patchReport.js